export default __webpack_public_path__ + "static/media/proctor-suspicious-activity-flagged.6e01671e.svg";